import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { CHAT_CLIENTS_REPOSITORY } from '../domain/repositories/chat-clients.repository';
import { ORGANIZATIONS_REPOSITORY } from '../domain/repositories/organizations.repository';
import { STAFF_CHAT_BLOCK_REPOSITORY } from '../domain/repositories/staff-chat-block.repository';
import { ChatClientsRemoteDatasource } from './datasources/remote/chat-clients.remote-datasource';
import { OrganizationsRemoteDatasource } from './datasources/remote/organizations.remote-datasource';
import { ChatClientMapper } from './mappers/chat-client.mapper';
import { OrganizationMapper } from './mappers/organization.mapper';
import { ChatClientsRepositoryImpl } from './repositories/chat-clients.repository.impl';
import { OrganizationsRepositoryImpl } from './repositories/organizations.repository.impl';
import { StaffChatBlockRepositoryImpl } from './repositories/staff-chat-block.repository.impl';

export function provideCommunicationData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    ChatClientsRemoteDatasource,
    OrganizationsRemoteDatasource,
    ChatClientMapper,
    OrganizationMapper,
    { provide: CHAT_CLIENTS_REPOSITORY, useClass: ChatClientsRepositoryImpl },
    { provide: ORGANIZATIONS_REPOSITORY, useClass: OrganizationsRepositoryImpl },
    { provide: STAFF_CHAT_BLOCK_REPOSITORY, useClass: StaffChatBlockRepositoryImpl },
  ]);
}
